import React, { FC, PropsWithChildren } from 'react';
import { ReactComponent as Logo } from 'icons/logo_summit.svg';
import { ReactComponent as Phone } from 'icons/phone.svg';
import styles from './AuthEntryLayout.module.scss';

interface Props { title: string; }

const AuthEntryLayout: FC<PropsWithChildren<Props>> = ({ title, children }) => (
  <div className={styles.page}>
    <header className={styles.header}>
      <div className={styles.headerInner}>
        <Logo className={styles.logo} role="img" aria-label="Саммит" />
        <a className={styles.contact} href={`tel:${(process.env.SUPPORT_PHONE || '88006009226').replace(/[^\d+]/g, '')}`} aria-label="Позвонить в Саммит">
          <Phone aria-hidden="true" />
          <span className={styles.contactDetails}>
            <span className={styles.phone}>8 800 600 92 26</span>
          </span>
        </a>
      </div>
    </header>
    <main className={styles.main}>
      <section className={styles.login} aria-labelledby="auth-title">
        <h1 id="auth-title" className={styles.heading}>{title}</h1>
        <div className={styles.card}>{children}</div>
      </section>
    </main>
    <footer className={styles.footer}>
      <div>© 2011 — {new Date().getFullYear()} АО МФК «Саммит»</div>
    </footer>
  </div>
);

export default AuthEntryLayout;
